import React from 'react';

const WeeklyPrintView = ({ week, dates, teacherName, weeklyData, showWeekends }) => {
  if (!week) return null;

  return (
    <div className="d-none d-print-block" style={{ width: '100%', marginTop: 0, paddingTop: 0 }}>
      <div className="d-flex justify-content-between align-items-center border-bottom pb-1 mb-2">
        <div>
          <h5 className="fw-bold mb-1 mt-0">Semanário de Classe &mdash; Semana {week.split('-W')[1]} ({week.split('-W')[0]})</h5>
          <div className="d-flex gap-4">
            <span style={{ fontSize: '0.85rem' }}><strong>Professor(a):</strong> {teacherName}</span>
            <span style={{ fontSize: '0.85rem' }} className="ms-3"><strong>Período:</strong> {dates.start} até {dates.end}</span>
          </div>
        </div>
      </div>

      <div className="mb-4 pb-2 border-bottom border-dark" style={{ fontSize: '0.85rem' }}>
        <div className="mb-1"><strong>Tema da Semana:</strong> {weeklyData.theme || 'Nenhum tema definido'}</div>
        <div><strong>Objetivos:</strong> {weeklyData.objectives || 'Nenhum objetivo definido'}</div>
      </div>

      <table className="table table-bordered border-dark" style={{ tableLayout: 'fixed', width: '100%', borderColor: '#000', margin: 0, marginTop: '0.6rem', pageBreakInside: 'auto' }}>
        <thead className="table-light text-dark" style={{ display: 'table-header-group' }}>
          <tr>
            {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', ...(showWeekends ? ['saturday', 'sunday'] : [])].map((day, index) => {
              const baseName = day === 'tuesday' ? 'Terça-feira' : day === 'wednesday' ? 'Quarta-feira' : day === 'thursday' ? 'Quinta-feira' : day === 'friday' ? 'Sexta-feira' : day === 'saturday' ? 'Sábado' : day === 'sunday' ? 'Domingo' : 'Segunda-feira';
              const dateStr = dates.weekDays && dates.weekDays[index] ? `\n(${dates.weekDays[index]})` : '';
              return (
                <th key={day} className="text-center align-middle border-dark p-1" style={{ width: showWeekends ? '14.28%' : '20%', whiteSpace: 'pre-wrap', fontSize: '0.85rem' }}>
                  {baseName}{dateStr}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody style={{ display: 'table-row-group' }}>
          <tr style={{ pageBreakInside: 'auto' }}>
            {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', ...(showWeekends ? ['saturday', 'sunday'] : [])].map((day) => {
              return (
                <td key={day} className="border-dark p-2" style={{ whiteSpace: 'pre-wrap', verticalAlign: 'top', fontSize: '0.85rem', wordBreak: 'break-word', pageBreakInside: 'auto' }}>
                  {weeklyData[day] ? weeklyData[day] : <span className="text-muted fst-italic">Sem planejamento</span>}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default WeeklyPrintView;
